<template>

</template>
<script>
export default {
  data () {
    this.$router.push({
      path: '/tourist/goods',
      query: {
        key: this.$route.query.key
      }
    })
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/tourist/goods/refreshsearch.vue